import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const ReferralShareSheetMessageSchema = z.object({
  share_sheet_message: z.string(),
  share_sheet_message_non_cardholder: z.string(),
  share_sheet_link: z.string(),
})

export type ReferralShareSheetMessage = z.infer<typeof ReferralShareSheetMessageSchema>

export function useReferralShareSheetMessageParameterStore() {
  return useMesaParameterStore('referral_share_sheet_message')
}
